import map from 'lodash-es/map';
import filter from 'lodash-es/filter';
import mapValues from 'lodash-es/mapValues';
import toPairs from 'lodash-es/toPairs';
import reverse from 'lodash-es/reverse';
import shuffle from 'lodash-es/shuffle';
import sortBy from 'lodash-es/sortBy';
import reduce from 'lodash-es/reduce';
import chunk from 'lodash-es/chunk';

// chain function is not supported in lodash-es, see details here:
// https://github.com/lodash/lodash/issues/3298#issuecomment-341685354
// so need to create a custom chain function

// just add here the lodash functions you want to support
const chainableFunctions = {
  toPairs,
  filter,
  reduce,
  map,
  sortBy,
  reverse,
  shuffle,
  chunk,
};

export const customChain = <T>(input: T) => {
  let value: any = input;
  const wrapper = {
    ...mapValues(chainableFunctions, (f: any) => (...args: any[]) => {
      // lodash always puts input as the first argument
      value = f(value, ...args);
      return wrapper;
    }),
    value: () => value,
  };
  return wrapper;
};
